import { useAppStore } from '@/store/useAppStore';
import { useTrueGenericFilterSortStore } from '@/store/useFilterSortStore';
import { documentEditorStore } from '@/store/documentEditor';
import { queryClient } from '@/services/queryClient';

/**
 * Remove all client-side state that may belong to the authenticated user.
 *
 * Query keys are intentionally shared between users, so invalidating them is not
 * sufficient: inactive queries could still expose the previous user's data until
 * their next refetch. Clearing the client also cancels/destroys in-flight queries
 * so they cannot repopulate the cache after logout.
 *
 * useAppStore and the document editor store are both persisted, so their state
 * outlives the tab unless it is reset here.
 */
export const resetUserSession = (): void => {
  queryClient.clear();

  useAppStore.getState().reset();
  useTrueGenericFilterSortStore.getState().reset();
  documentEditorStore.getState().resetState();
};
